import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

console.log = () => {};
console.debug = () => {};
console.warn = () => {};
console.error = () => {};

const app = createApp(App);

app.use(router);
app.mount('#app');